/**
 * src/components/directory-page/DirectoryPage.js
 *
 * Página del directorio. Contendrá FeaturedSection (oro) y SilverSection (plata).
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal } from '@core/signal.js'

define('DirectoryPage', ({ params = {} } = {}) => {
    const initialCategory = params.categoria ?? ''
    const sharedCategory  = signal(initialCategory)

    return h('div', { className: 'page page--directory' },
        c('Header'),
        c('FeaturedSection', {
            initialCategory,
            onCategoryChange: slug => sharedCategory.set(slug)
        }),
        c('SilverSection', {
            initialCategory,
            categorySignal: sharedCategory
        })
    )
})
